import { statusColorCodes, statusColors } from 'consts/reservations/statusColors';

export const getStatusColorCode = (code: string | undefined): string => {
  const color = !!code && Object.keys(statusColors).find(c => statusColors[c].includes(code));

  if (color) {
    const hexCode = statusColorCodes[color as keyof typeof statusColorCodes];

    return hexCode;
  }

  return '#ededed';
};
